import {
  PromotionContestActiveSchema,
  PromotionContestFormValues,
  PromotionContestPayload,
  PromotionContestResponse,
} from './types/ContestTypes';
import {
  contestV1ApiToFormValues,
  createEmptyContestV1Values,
} from './contestShared';
import {
  createEmptyContestV2Values,
  v2RewardFieldsFromApiAmounts,
} from './contestV2Types';

export function createEmptyContestFormValues(): PromotionContestFormValues {
  return {
    activeSchema: 'v1',
    v1: createEmptyContestV1Values(),
    v2: createEmptyContestV2Values(),
  };
}

export function contestPayloadToFormValues(
  payload: PromotionContestPayload | null | undefined,
): PromotionContestFormValues {
  if (!payload) {
    return createEmptyContestFormValues();
  }

  const v2Defaults = createEmptyContestV2Values();
  const fromApiV2 = payload.v2;
  const v2 = fromApiV2
    ? {
      ...v2Defaults,
      triggerIdentifier: fromApiV2.triggerIdentifier ?? '',
      title: fromApiV2.title ?? '',
      message: fromApiV2.message ?? '',
      episodes: Array.isArray(fromApiV2.episodes) && fromApiV2.episodes.length > 0
        ? fromApiV2.episodes
        : v2Defaults.episodes,
      ...v2RewardFieldsFromApiAmounts(
        fromApiV2.sapphiresAmount ?? 0,
        fromApiV2.heartsAmount ?? 0,
      ),
    }
    : v2Defaults;

  const activeSchema: PromotionContestActiveSchema = payload.activeSchema === 'v2' ? 'v2' : 'v1';

  return {
    activeSchema,
    v1: contestV1ApiToFormValues(payload.v1),
    v2,
  };
}

export function buildContestSavePayload(
  values: PromotionContestFormValues,
  options: { remove?: boolean } = {},
) {
  return {
    activeSchema: values.activeSchema,
    remove: Boolean(options.remove),
    v1: values.activeSchema === 'v1' ? values.v1 : createEmptyContestV1Values(),
    v2: values.activeSchema === 'v2' ? values.v2 : createEmptyContestV2Values(),
  };
}

export type { PromotionContestResponse };
